import { render, staticRenderFns } from "./DynamicFieldsCard.vue?vue&type=template&id=53f2c764&scoped=true&"
import script from "./DynamicFieldsCard.vue?vue&type=script&lang=js&"
export * from "./DynamicFieldsCard.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFieldsCard.vue?vue&type=style&index=0&id=53f2c764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f2c764",
  null
  
)

export default component.exports